/**
 * URL builders for the public-facing semantic routes.
 *
 * Why:
 *   - Item #11 spec wants `/[cidade]/[categoria]/[slug]` everywhere a business
 *     is linked to from cards, search, similar lists, breadcrumbs, etc.
 *   - We *must* never expose user emails or CPFs. The legacy id format
 *     `email_nome` should be detectable so legacy links can be redirected.
 *   - When the slug fields are missing (e.g., a freshly-created business
 *     before backfill), fall back to `/negocio/:id` so navigation never
 *     breaks.
 */

/** Predicate: is the URL identifier a legacy "email_nome" id? */
export function isLegacyBusinessIdentifier(id) {
  if (!id) return false;
  return /@|\./.test(id) && id.includes('_');
}

/** Build the canonical SEO URL for a business object. */
export function buildBusinessUrl(business) {
  if (!business) return '/';
  const muni = business.municipio_slug;
  const cat = business.categoria_slug;
  const slug = business.slug;
  if (muni && cat && slug) {
    return `/${muni}/${cat}/${slug}`;
  }
  // Fallback during transition / missing data
  return `/negocio/${business.id || ''}`;
}

/** Build the URL for filtering by tag (item #7/#8). */
export function buildTagUrl(tagSlug) {
  if (!tagSlug) return '/';
  return `/tags/${tagSlug}`;
}

/** Slugify (mirror of backend `core/slug_utils.slugify`). */
export function slugifyClient(text) {
  if (!text) return '';
  return String(text)
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '') // strip diacritics
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[-\s]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
